import React from "react";

const sponsorLogos = [
  "crankcoffeeco.webp",
  "franklin.webp",
  "hearinglife.webp",
  "honestlot.webp",
  "igwealthmanagement.webp",
  "nealbrothers.webp",
  "pickleballmanagementgroup.webp",
  "pickleplex.webp",
  "vaughantourism.webp",
];

const SponsorFooter = () => {
  return (
    <div className="bg-gradient-to-b from-[#f0efe9] via-[#dfe2e3] to-[#2a2a2d] py-6 text-zinc-800 shadow-[inset_0_1px_0_rgba(0,0,0,0.08)]">
      <div className="container mx-auto px-4">
        <p className="mb-4 text-center text-xs font-semibold uppercase tracking-[0.25em] text-zinc-700 sm:text-sm">
          Sponsored by:
        </p>

        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 md:gap-5 lg:gap-6">
          {sponsorLogos.map((logo) => (
            <img
              key={logo}
              src={`/sponsors/2026/${logo}`}
              alt={logo.replace(/\.[^.]+$/, "")}
              className="h-[56px] w-[120px] object-contain opacity-90 sm:h-[64px] sm:w-[140px] md:h-[72px] md:w-[160px] lg:h-[80px] lg:w-[180px]"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SponsorFooter;
